import { render, staticRenderFns } from "./Gigly.vue?vue&type=template&id=721a34d0&scoped=true&"
import script from "./Gigly.vue?vue&type=script&lang=js&"
export * from "./Gigly.vue?vue&type=script&lang=js&"
import style0 from "./Gigly.vue?vue&type=style&index=0&id=721a34d0&prod&lang=css&"
import style1 from "./Gigly.vue?vue&type=style&index=1&id=721a34d0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721a34d0",
  null
  
)

export default component.exports